import { render, staticRenderFns } from "./bankNumberFromWrapper.vue?vue&type=template&id=3bcf2928&scoped=true&"
import script from "./bankNumberFromWrapper.vue?vue&type=script&lang=js&"
export * from "./bankNumberFromWrapper.vue?vue&type=script&lang=js&"
import style0 from "./bankNumberFromWrapper.vue?vue&type=style&index=0&id=3bcf2928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf2928",
  null
  
)

export default component.exports